export default __webpack_public_path__ + "static/media/brochureImg.14d328df.webp";